import Service from "../Service";
const resource = "transactionpermit/";

export default {

    byUser(obj, requestID) {
        return Service.post(resource + "byuser", obj, {
            params: { requestID: requestID },
        });
    },

    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },

};